import React from 'react';
import './HifzCourse.css';

const HifzCourse = () => {
    return (
        <div className="course-container">
            <div className="content-section">
                <h2>Hifz Course</h2>
                <p>The Hifz Course is specifically designed for students who have a strong desire to memorize the entire Quran...</p>
                
                <h3>Course Objectives:</h3>
                <p>This course focuses on the following key areas:</p>
                <ul>
                    <li><strong>Systematic Memorization:</strong> Develop a clear and manageable memorization plan...</li>
                    <li><strong>Retention and Review:</strong> Implement daily and weekly review sessions...</li>
                    <li><strong>Spiritual Development:</strong> Foster a deep spiritual connection to the Quran...</li>
                </ul>
                
                <h3>Course Structure:</h3>
                <ul>
                    <li><strong>Phase 1 – Foundation:</strong> Establish the groundwork for memorization...</li>
                    <li><strong>Phase 2 – Initial Memorization:</strong> Begin the process of memorization...</li>
                    <li><strong>Phase 3 – Intermediate Memorization:</strong> Continue with longer Surahs...</li>
                    <li><strong>Phase 4 – Completion and Revision:</strong> Focus on the completion of memorization...</li>
                </ul>
                
                <h3>Key Features of the Course:</h3>
                <ul>
                    <li>Personalized memorization plans tailored to individual progress...</li>
                    <li>Daily and weekly review sessions to reinforce memory...</li>
                    <li>One-on-one mentoring and support...</li>
                    <li>Spiritual guidance to help students stay connected...</li>
                </ul>

                <h3>Benefits of Memorizing the Quran:</h3>
                <ul>
                    <li><strong>Spiritual Reward:</strong> Memorizing the Quran is considered a noble act, earning great rewards in this life and the Hereafter.</li>
                    <li><strong>Personal Growth:</strong> Strengthen your spiritual and mental discipline through the memorization process.</li>
                    <li><strong>Community Leadership:</strong> As a Hafiz, serve as a role model and leader within your community.</li>
                    <li><strong>Connection with the Quran:</strong> Develop a lifelong connection with the Quran through consistent recitation and reflection.</li>
                    <li><strong>Preserving the Quran:</strong> Carry the responsibility of preserving the Quranic text and teachings for future generations.</li>
                </ul>
            </div>
            <div className="image-section">
                <img src="./images/jjs.PNG" alt="Hifz Course" />
            </div>
        </div>
    );
};

export default HifzCourse;
